<div class="modal fade" tabindex="-1" [id]="'confirmationCreatePackageModal'">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <i class="bi bi-exclamation-circle-fill fs-1 text-warning mb-2"></i>
        <h4 class="modal-title fw-bold">{{ (head ? head : 'COMMON.WILL_BE_CREATED') | translate }}</h4>
        <h5 *ngIf="head5" class="modal-title">{{ head5 }}</h5>
      </div>
      <div class="modal-body text-center">
        <p *ngIf="packages?.length" class="ms-1 me-1">{{ 'COMMON.SELECT_EXISTING_FROM_CREATING' | translate }}</p>
        <div class="container mb-2">
          <div class="row">
            <div *ngIf="packages?.length" class="packages_container">
              <div title="list container" class="packages_container_list">
                <div *ngFor="let package of packages" class="packages_container_item">
                  <div>
                    <input class="form-check-input package-select-pb" type="checkbox" name="existingPackageRadio"
                      [id]="package.id" [checked]="package.id==packageSelectedId"
                      (click)="checkClicked(package.id,package.remainingTestDays)">
                  </div>
                  <div class="fw-bold">{{package.id}}</div>
                  <div class="fw-bold">{{package.packageType.name}}</div>
                  <div class="packages_container_item_assigned">{{package.assigned.name}}</div>
                  <div *ngIf="package.packageCategoryId!=2">{{package.remainingTestDays}} rtd</div>
                  <!--({{'LICENSE.ASSIGNED_TEST_DAYS' | translate }})-->
                </div>
              </div>
              <p *ngIf="packages!.length >= 10" class="package_list_notice">{{'LICENSE.MAX_EXISITNG_PACKAGES' | translate }}</p>
            </div>
          </div>
        </div>
        <div *ngIf="packages?.length" class="clear-pb" [ngClass]="{'clear-pb-deactive':!packageSelectedId}"
          (click)="checkClicked(packageSelectedId)">
          <div>{{ 'COMMON.CLEAR'| translate}}</div>
        </div>
        <div *ngIf="packageSelectedId" class="single-package-message">{{ 'COMMON.SURE_TO_CONTINUE_CREATE_ONLY_ONE'|
          translate}}</div>
        <div *ngIf="alignTestDaysMessage && packageSelectedId && testDays! < originTestDays!"
          class="single-package-message">{{ 'COMMON.SURE_TO_CONTINUE_ALIGN_TEST_DAYS'| translate}}</div>
        <p>{{ (message ? message : 'COMMON.SURE_TO_CONTINUE_CREATE') | translate:{ x: id } }}</p>
      </div>
      <div class="modal-footer">
        <button *ngIf="!hideConfirm" type="button" class="btn btn-dark" data-bs-dismiss="modal" (click)="confirm.emit()"
          data-bs-toggle="modal" [attr.data-bs-target]="'#progressModal'">{{ 'COMMON.CONFIRM'
          | translate }}</button>
        <button *ngIf="!hideConfirm" #cancel type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{
          'COMMON.CANCEL' | translate
          }}</button>
        <button *ngIf="hideConfirm" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
          (click)="confirm.emit()">{{
          'COMMON.CANCEL' | translate
          }}</button>
      </div>
    </div>
  </div>
</div>